<template>
  <div
    v-show="isVisible"
    class="alert"
    role="alert"
    v-bind:class="{
      'stickeralert mx-0 mt-0 px-0': position == 'top',
      'cookiealert mb-0 text-center': position == 'bottom',
    }">
    <slot></slot>
  </div>
</template>

<script>
// Based on
// Bootstrap Cookie Alert by Wruczek https://github.com/Wruczek/Bootstrap-Cookie-Alert
// Released under MIT license

export default {
  name: 'SiteAlert',
  props: {
    position: {
      type: String,
      default: null,
      required: true,
    },
  },
  data: function () {
    return {
      isVisible: false,
      //
      names: {
        top: 'acceptSticker',
        bottom: 'acceptCookies',
      },
    };
  },
  computed: {
    // When clicking on the agree button, create a "days" cookie to remember user's choice and close the banner
    days: function () {
      switch (this.position) {
        case 'top':
          return 1;
        case 'bottom':
          return 365;
      }
      return 0;
    },
  },
  methods: {
    acceptCookie(name) {
      this.setCookie(name, true, this.days);
      this.isVisible = false;
    },
    setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      const expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;SameSite=Strict';
    },
    getCookie(cname) {
      const name = cname + '=';
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    },
  },
  created() {
    this.$root.$on('accept-сookie', (data) => {
      if (data == this.position) {
        this.acceptCookie(this.names[data]);
      }
    });

    // Show the alert if we cant find the "acceptCookies" cookie
    if (!this.getCookie(this.names[this.position])) {
      //cookieAlert.classList.add('show'); // был транзишен на скрытие, но убран, наверное надо бы вернуть
      this.isVisible = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.cookiealert {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  // opacity: 0;
  border-radius: 0;
  // transform: translateY(100%);
  // transition: all 500ms ease-out;
  color: #ecf0f1;
  background-color: #212327;
  /* &.show {
    opacity: 1;
    transform: translateY(0%);
    transition-delay: 1000ms;
  } */
  a {
    text-decoration: underline;
  }
  .acceptcookies {
    margin-left: 10px;
    vertical-align: baseline;
  }
}

.stickeralert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  // opacity: 0;
  border-radius: 0;
  // transform: translateY(-100%);
  // transition: all 500ms ease-out;
  color: #ecf0f1;
  background: #105990;
  /* &.show {
    opacity: 1;
    transform: translateY(0%);
    transition-delay: 1000ms;
  } */
  a {
    text-decoration: underline;
  }
  .stickerclose {
    margin-left: 10px;
    vertical-align: baseline;
  }
}
</style>
